import { Component, Input } from '@angular/core';
import { MdbNotificationRef } from 'mdb-angular-ui-kit/notification';

@Component({
  selector: 'app-info-toast',
  standalone: true,
  template: `
    <div class="schnapsen-toast info-toast">
      <div class="toast-content">
        <div class="toast-icon">
          <i class="fas fa-info-circle"></i>
        </div>
        <div class="toast-message">
          {{ message || 'Information' }}
        </div>
        <button
          type="button"
          class="toast-close"
          aria-label="Close"
          (click)="close()"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .schnapsen-toast {
        min-width: 320px;
        max-width: 400px;
        background: #f8f9fa;
        border: 2px solid;
        border-radius: 8px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        font-family: 'Georgia', serif;
        margin: 8px;
      }

      .info-toast {
        border-color: #17a2b8;
        background: linear-gradient(135deg, #d1ecf1 0%, #f8f9fa 100%);
      }

      .toast-content {
        display: flex;
        align-items: center;
        padding: 16px 20px;
        gap: 12px;
      }

      .toast-icon {
        color: #17a2b8;
        font-size: 20px;
        flex-shrink: 0;
      }

      .toast-message {
        flex: 1;
        color: #0c5460;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.4;
      }

      .toast-close {
        background: none;
        border: none;
        color: #6c757d;
        font-size: 14px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: all 0.2s ease;
        flex-shrink: 0;
      }

      .toast-close:hover {
        background: rgba(0, 0, 0, 0.1);
        color: #495057;
      }

      /* Mobile responsive styles */
      @media (max-width: 480px) {
        .schnapsen-toast {
          min-width: 280px;
          max-width: calc(100vw - 16px);
          margin: 4px 4px 4px auto;
        }
        
        .toast-content {
          padding: 12px 16px;
          gap: 10px;
        }
        
        .toast-message {
          font-size: 13px;
        }
      }
      
      @media (max-width: 360px) {
        .schnapsen-toast {
          min-width: 240px;
          max-width: calc(100vw - 12px);
          margin: 4px 4px 4px auto;
        }
        
        .toast-content {
          padding: 10px 12px;
          gap: 8px;
        }
        
        .toast-icon {
          font-size: 18px;
        }
        
        .toast-message {
          font-size: 12px;
        }
        
        .toast-close {
          font-size: 12px;
          padding: 2px;
        }
      }
    `,
  ],
})
export class InfoToastComponent {
  @Input() message: string = '';

  constructor(public notificationRef: MdbNotificationRef<InfoToastComponent>) {}

  close(): void {
    this.notificationRef.close();
  }
}
